import { notImplementedFunction } from '../defaultFillers';
import { ILocationDataContext } from './LocationDataTypes';

export const defaultLocationDataContext: ILocationDataContext = {
    title: '',
    description: '',
    setLocationData: notImplementedFunction,
};
